import { Control } from '../control';
import { isArray } from 'util';

export class ControlBuilder {
  static fromJson(json) {
    return (json)
      ? new Control(
        json.hash,
        json.name,
        json.protocol
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ControlBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/control.builder.ts